<template>
  <div class="image-grid-standard-tmp">
    <div
      class="image-grid-standard-tmp__inner"
      :class="[
        'item-count__' + imageUrls.length,
        { 'hightlight-first-img': highlightFirstImage },
        { 'full-size-block': isFullSize },
      ]"
    >
      <cloudinary-picture
        v-for="(url, index) in imageUrls"
        :key="index"
        class="media-item"
        :class="`media-item__${index}`"
        :url="url"
        :sizes="getDimensions(index)"
        :sharpen="80"
        auto-quality="best"
        :use-picture="false"
        :aspect-ratio="0"
        :scroll-container-id="scrollContainerId"
      />
    </div>
  </div>
</template>

<script>
import CloudinaryPicture from '../common/picture/cloudinaryPicture.vue'

export default {
  name: 'ImageGridStandard',
  components: {
    CloudinaryPicture,
  },
  props: {
    highlightFirstImage: {
      type: Boolean,
      default: false,
    },
    isFullSize: {
      type: Boolean,
      default: false,
    },
    imageUrls: {
      type: Array,
      default: () => ['', '', '', ''],
    },
    scrollContainerId: {
      type: String,
      default: null,
    },
    dimensions: {
      type: Object,
      default: () => ({
        small: {
          width: 220,
        },
        medium: {
          width: 320,
        },
        large: {
          width: 400,
        },
      }),
    },
  },
  methods: {
    getDimensions (index) {
      const { small, medium, large } = this.dimensions
      if (this.highlightFirstImage && index === 0) {
        return this.isFullSize ? this.generateDimensions(medium, medium, large) : this.generateDimensions(small, medium, large)
      }
      switch (this.imageUrls.length) {
        case 4:
          return this.generateDimensions(small, small, small)
        case 3:
          if (index === 0) {
            return this.generateDimensions(small, medium, large)
          } else {
            return this.generateDimensions(small, small, small)
          }
        default:
          return this.generateDimensions(small, medium, large)
      }
    },
    generateDimensions (small, medium, large) {
      return {
        small,
        medium,
        large,
      }
    },
  },
}
</script>

<style lang="scss">
.image-grid-standard-tmp {
  $this: &;

  height: 100%;
  padding: 4px;

  .epi-picture > div {
    border-radius: 4px;
  }

  &__inner {
    height: 100%;
    display: flex;
    flex-wrap: wrap;

    &.item-count__1 {
      .media-item {
        width: 100%;
        height: 100%;
      }
    }

    &.item-count__2 {
      .media-item {
        width: 100%;
        height: 50%;
      }
    }

    &.item-count__3 {
      .media-item__0 {
        width: 100%;
        height: 50%;
      }

      .media-item__1,
      .media-item__2 {
        width: 50%;
        height: 50%;
      }
    }
    // 4 pictures default
    .media-item {
      display: flex;
      width: 50%;
      padding: 4px;
      height: 50%;
    }

    @mixin hightlight-img() {
      .media-item {
        display: flex;
        width: 33.33%;
        padding: 4px;
        height: 40%;
      }

      .media-item__0 {
        width: 100%;
        height: 60%;
      }
    }

    &.hightlight-first-img {
      .media-item {
        padding: 2px;
      }

      @include media-breakpoint-up(md) {
        @include hightlight-img();
      }

      &.full-size-block {
        @include hightlight-img();
      }
    }
  }
}
</style>
